/**
 * Dashboard "What's new" feed. Newest first; keep entries short (≤ ~60 chars)
 * and link each one to the place the user can try it.
 */

export interface WhatsNewEntry {
  text: string;
  href: string;
}

export const WHATS_NEW: WhatsNewEntry[] = [
  {
    text: 'Scales and triads now advance on a metronome',
    href: '/learn/major-pentatonic-scale',
  },
  { text: 'Play your own tabs on the fretboard', href: '/learn?family=tabs' },
  { text: 'Guided soloing over chord changes', href: '/learn/guided-solo' },
  {
    text: 'Triads in all four qualities and string sets',
    href: '/learn?family=triads',
  },
  {
    text: 'Blues and major/minor scale positions',
    href: '/learn?family=blues',
  },
];
